'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialLinkedin = function IoSocialLinkedin(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.6 5c1.4 0 2.4 1 2.4 2.3v25.1c0 1.4-1 2.6-2.4 2.6h-25c-1.4 0-2.6-1.2-2.6-2.6v-25.1c0-1.3 1.2-2.3 2.6-2.3h25z m-18.3 25v-13.4h-4.3v13.4h4.3z m-2-15.4c1.4 0 2.3-1 2.3-2.3 0-1.3-0.8-2.3-2.3-2.3s-2.3 1-2.3 2.3c0 1.3 0.9 2.3 2.3 2.3z m17.7 15.4v-7.8c0-4-2.1-5.9-4.9-5.9-2.3 0-3.3 1.4-3.9 2.2v-1.9h-4.3v13.4h4.3v-7.6c0-0.4 0-0.8 0.1-1.1 0.3-0.8 1-1.5 2.2-1.5 1.6 0 2.2 1.1 2.2 2.9v7.3h4.3z' })
        )
    );
};

exports.default = IoSocialLinkedin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-linkedin.js
// module id = 2939
// module chunks = 168707334958949